
<div >
  <app-search-location (resultsChanged)="onResultChanged($event)" (calculError)="onCalculError($event)"></app-search-location>

  <ng-container *ngIf="displayResult()">
    <app-result [searchResults]="searchResults" [error]="error"></app-result>
  </ng-container>
</div>

<router-outlet name="print"></router-outlet>